import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";
import { heroImage } from "../../data/projects";

const Hero = () => {
  const { t } = useLang();
  const go = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="hero" data-testid="hero-section" className="relative pt-28 md:pt-32">
      <div className="container-x">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-end">
          {/* Left: Text */}
          <div className="lg:col-span-7 pb-10 lg:pb-20">
            <div className="font-mono-label text-[#666] mb-8 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-[#A89F91]" />
              {t("hero.kicker")}
            </div>

            <h1 className="font-display text-[3.4rem] sm:text-7xl md:text-8xl lg:text-[9rem] text-[#111]">
              <span className="block">{t("hero.title_1")}</span>
              <span className="block italic font-light text-[#A89F91]" style={{ fontFamily: "'Cabinet Grotesk', sans-serif", fontWeight: 400 }}>
                {t("hero.title_2")}
              </span>
              <span className="block">{t("hero.title_3")}</span>
            </h1>

            <p className="mt-10 max-w-xl text-[#444] text-base md:text-lg leading-relaxed">
              {t("hero.subtitle")}
            </p>

            <div className="mt-10 flex flex-wrap items-center gap-4">
              <button
                data-testid="hero-cta-primary-btn"
                onClick={() => go("contacto")}
                className="btn-primary"
              >
                {t("hero.cta_primary")}
                <ArrowUpRight size={16} strokeWidth={1.5} />
              </button>
              <button
                data-testid="hero-cta-secondary-btn"
                onClick={() => go("proyectos")}
                className="btn-secondary"
              >
                {t("hero.cta_secondary")}
              </button>
            </div>
          </div>

          {/* Right: Image */}
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[3/4] lg:aspect-[3/4.4] overflow-hidden">
              <img
                src={heroImage}
                alt="AARK featured architecture"
                className="absolute inset-0 w-full h-full object-cover"
                loading="eager"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 hidden md:block bg-[#FAFAFA] border border-[#E5E5E5] px-6 py-4">
              <div className="font-mono-label text-[#666]">Valencia · ES</div>
              <div className="font-display text-2xl mt-1">39°28'N</div>
            </div>
          </div>
        </div>

        {/* Stats strip */}
        <div className="mt-16 lg:mt-24 grid grid-cols-3 border-t border-[#E5E5E5]">
          {[
            { v: t("hero.stat_1_value"), l: t("hero.stat_1_label") },
            { v: t("hero.stat_2_value"), l: t("hero.stat_2_label") },
            { v: t("hero.stat_3_value"), l: t("hero.stat_3_label") },
          ].map((s, i) => (
            <div
              key={i}
              className={`py-8 md:py-10 ${i !== 2 ? "border-r border-[#E5E5E5]" : ""}`}
            >
              <div className="font-display text-3xl md:text-5xl text-[#111]">{s.v}</div>
              <div className="font-mono-label text-[#666] mt-3">{s.l}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
